import RevenueSharesGlobalView from '../components/revenue-shares/revenue-shares-global-view';
import { DynamicDrawerProvider } from '../context/dynamic-drawer.context';

const RevenueShares = (): JSX.Element => (
  <DynamicDrawerProvider>
    <RevenueSharesGlobalView />
  </DynamicDrawerProvider>
);

export default RevenueShares;
